export const numberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
  maximumSignificantDigits: 4,
  useGrouping: false,
});
